import { createContext, useState, useMemo, useCallback } from 'react'
import { node } from 'prop-types'
import { api } from 'api'

export const campaignContext = createContext({})

export const CampaignProvider = ({ children }) => {
  const [byId, setById] = useState({})

  const fetchCampaigns = useCallback(
    id =>
      api.get(`/api/v1/integrations/inbound/listExternalEntity/${id}/campaigns`).then(resp => {
        setById(prev => ({ ...prev, [id]: resp.data }))
        return resp
      }),
    [],
  )

  const value = useMemo(
    () => ({
      byId,
      fetchCampaigns,
    }),
    [byId, fetchCampaigns],
  )

  return <campaignContext.Provider value={value}>{children}</campaignContext.Provider>
}

CampaignProvider.propTypes = {
  children: node.isRequired,
}
